module.exports = __webpack_public_path__ + "img/router.3c0ee938.png";